import LoginLogo from "../assets/LoginLogo.tsx"
import { getConnectxLogoSrc, getCurrentLoginBrand } from "../utils/loginBranding.ts"

interface DomainLoginLogoProps {
  className?: string
  connectxClassName?: string
  nexusVariant?: "landscape" | "square"
  logoUrl?: string | null
  companyName?: string
}

export const DomainLoginLogo = ({
  className = "",
  connectxClassName = "mx-auto w-full max-w-md h-auto object-contain",
  nexusVariant = "landscape",
  logoUrl,
  companyName,
}: DomainLoginLogoProps) => {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={companyName || "Company logo"}
        className="mx-auto max-h-24 w-auto max-w-xs object-contain"
      />
    )
  }

  const loginBrand = getCurrentLoginBrand()

  if (loginBrand === "connectx") {
    return (
      <img
        src={getConnectxLogoSrc()}
        alt="ConnectX"
        className={connectxClassName}
      />
    )
  }

  return (
    <div className={className}>
      <LoginLogo variant={nexusVariant} />
    </div>
  )
}
